import { render, staticRenderFns } from "./ResponsibilitiesList.vue?vue&type=template&id=33aa5910&"
import script from "./ResponsibilitiesList.vue?vue&type=script&lang=js&"
export * from "./ResponsibilitiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports